export const HEARTBEAT = '--heartbeat--'
export const AJAX_TIMEOUT = 15000
export const AJAX_METHODS = {
  get: 'get',
  post: 'post',
}
